import AddArtItem from "./AddArtItem";
import ArtItems from "./ArtItems/ArtItems";

export default { AddArtItem, ArtItems };
